import blocksConfig from '@/blocks.config'
import Blocks from '../components/blocks'

export const BlocksComponent = blocksConfig.BlocksComponent || Blocks
